module.exports = __webpack_public_path__ + "b2549b0e3137bf36b1680df6f091ea4b.MP3";